import { Component, Input, OnInit } from "@angular/core";
import { DataService_Student_Scan_History } from "../shared/data.service";

@Component({
	selector: "caass-student-scan-view-manual",
	templateUrl: "./student-scan-view-manual.component.html",
	styleUrls: ["./student-scan-view-manual.component.css"],
})
export class StudentScanViewManualComponent implements OnInit {
	constructor(private ScanHistoryService: DataService_Student_Scan_History) {}

	ngOnInit(): void {
		this.LoadScanDetails();
	}

	ngOnChanges() {
		this.LoadScanDetails();
	}

	///////////////////////////////////
	// Data
	///////////////////////////////////

	//Input
	@Input() SelectedEntry: any;

	//Form
	IDCardStatusDesc: any = "";
	Admin_PersonName: any = "";
	ManualComment: any = "";
	ReprintCardDesc: any = "";
	ChargeReprintDesc: any = "";
	PrintedTempDesc: any = "";
	ChargeTempDesc: any = "";
	PaidAmount: any = "";
	ReprintFee: any = "";
	TempIDFee: any = "";
	///////////////////////////////////

	///////////////////////////////////
	// Load Data
	///////////////////////////////////
	LoadScanDetails() {
		if (this.SelectedEntry == undefined) {
			return;
		}

		var result = this.ScanHistoryService.StudentManualScanInfoSelectList(this.SelectedEntry.ScanID);
		result.subscribe(
			(response) => {
				var r: any = response[0];

				this.IDCardStatusDesc = r.IDStatusDesc != "" ? r.IDStatusDesc : "N/A";
				this.Admin_PersonName = r.Admin_PersonName != "" ? r.Admin_PersonName : "N/A";
				this.ManualComment = r.ManualComment != "" ? r.ManualComment : "N/A";
				this.ReprintCardDesc = r.ReprintCardDesc != "" ? r.ReprintCardDesc : "N/A";
				this.ChargeReprintDesc = r.ChargeReprintDesc != "" ? r.ChargeReprintDesc : "N/A";
				this.PrintedTempDesc = r.PrintedTempDesc != "" ? r.PrintedTempDesc : "N/A";
				this.ChargeTempDesc = r.ChargeTempDesc != "" ? r.ChargeTempDesc : "N/A";
				this.PaidAmount = r.PaidAmount != "" ? "$" + r.PaidAmount : "N/A";
				this.ReprintFee = r.ReprintFee != "" ? "$" + r.ReprintFee : "N/A";
				this.TempIDFee = r.TempIDFee != "" ? "$" + r.TempIDFee : "N/A";
			},
			(error) => {}
		);
	}
	///////////////////////////////////
}
